var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _dec6, _dec7, _class2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _dec8, _dec9, _dec0, _class3, _descriptor8, _descriptor9, _descriptor0;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait, { MergeStrategy } from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import ExportableTraits from "./ExportableTraits";
export let KeyValueTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Key",
  description: "Key string."
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Value",
  description: "Value string."
}), _class = class KeyValueTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "key", _descriptor, this);
    _initializerDefineProperty(this, "value", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "key", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "value", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let WebCoverageServiceParameterTraits = (_dec3 = primitiveTrait({
  type: "string",
  name: "Output CRS",
  description: 'Output CRS (in EPSG format - eg "EPSG:4326").'
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Output format",
  description: "File format of output (defaults to GeoTIFF)."
}), _dec5 = objectArrayTrait({
  type: KeyValueTraits,
  idProperty: "key",
  name: "WCS subsets",
  description: 'Array of key-value pairs for subsets to be included in query parameters. For example `{key: "Time", value: "2020"}` will add query parameter `subset=Time("2020")`'
}), _dec6 = objectArrayTrait({
  type: KeyValueTraits,
  idProperty: "key",
  name: "Duplicate subset values",
  description: "If multiple values have been detected for a particular subset ID (key), then we can only use the first one as WCS only supports one value per subset. Each element in this array represents the **actual** value used for a subset which has multiple values."
}), _dec7 = objectArrayTrait({
  type: KeyValueTraits,
  idProperty: "index",
  merge: MergeStrategy.None,
  name: "Additional key-value parameters to add as URL query parameters",
  description: "Each key-value will be added to URL like so - `someurl.com?key=value`."
}), _class2 = class WebCoverageServiceParameterTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "outputCrs", _descriptor3, this);
    _initializerDefineProperty(this, "outputFormat", _descriptor4, this);
    _initializerDefineProperty(this, "subsets", _descriptor5, this);
    _initializerDefineProperty(this, "duplicateSubsetValues", _descriptor6, this);
    _initializerDefineProperty(this, "additionalParameters", _descriptor7, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "outputCrs", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "outputFormat", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "image/geotiff";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "subsets", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "duplicateSubsetValues", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "additionalParameters", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let ExportWebCoverageServiceTraits = (_dec8 = primitiveTrait({
  type: "string",
  name: "Linked WCS URL",
  description: "Gets or sets the URL of a WCS that enables clip-and-ship for this WMS item."
}), _dec9 = primitiveTrait({
  type: "string",
  name: "Linked WCS Coverage Name",
  description: "Gets or sets the coverage name for linked WCS for clip-and-ship."
}), _dec0 = objectTrait({
  type: WebCoverageServiceParameterTraits,
  name: "Linked WCS Parameters",
  description: "WCS Parameters included in `GetCoverage` requests (for clip-and-ship)."
}), _class3 = class ExportWebCoverageServiceTraits extends mixTraits(ExportableTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "linkedWcsUrl", _descriptor8, this);
    _initializerDefineProperty(this, "linkedWcsCoverage", _descriptor9, this);
    _initializerDefineProperty(this, "linkedWcsParameters", _descriptor0, this);
  }
}, _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "linkedWcsUrl", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "linkedWcsCoverage", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class3.prototype, "linkedWcsParameters", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export { ExportWebCoverageServiceTraits as default };